import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ICON } from '@core/util/icon';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { LawyerSearchState } from '@state/algolia-search/lawyer-search';
import { LawyerSearchDispatch } from '@state/algolia-search/lawyer-search/dispatch';
import {
	CreateLawFirmEmployeeComponent,
	CreateOrUpdateLawFirmEmployeeModel,
} from '../create-employee/create-employee.component';
import { LawFirm } from '@models/lawFirms';
import { LawFirmEmployee, LawFirmEmployeeType } from '@models/lawFirms';
import { Employee } from '@models/company';
import { TestHooks } from './lawyer.hooks';

@UntilDestroy()
@Component({
	selector: 'app-lawyer',
	templateUrl: './lawyer.component.html',
	styleUrls: ['./lawyer.component.scss'],
	standalone: false,
})
export class LawyerComponent {
	testHooks = TestHooks;
	public _lawyerName = '';
	public _lawyerFirstName = '';
	public _lawyerLastName = '';
	public ICON = ICON;
	public _focus = false;
	public hoverShadow = true;

	@ViewSelectSnapshot(LawyerSearchState.getList) searchResult;

	@Input() lawFirm: LawFirm;
	@Output() onSelectLawyer = new EventEmitter<Employee>();
	@Output() onCreateOrUpdateLawyer = new EventEmitter<Employee>();
	@Output() onRemoveLawyer = new EventEmitter();
	@Output() onFocus = new EventEmitter();

	constructor(
		private dialog: MatDialog,
		private lawyerSearchDispatch: LawyerSearchDispatch,
	) {}

	_onFocus() {
		this.onFocus.emit();
		this._focus = true;
	}

	setLawyer(ev: DropdownResult<LawFirmEmployee>) {
		if (ev.group === 1) {
			this.onSelectLawyer.emit(ev.result);
		}
	}

	removeLawyer() {
		this.onRemoveLawyer.emit();
		this._lawyerName = '';
	}

	createOrUpdateLawyer() {
		const lawFirmEmployeeModel: CreateOrUpdateLawFirmEmployeeModel = {
			name: this._lawyerName,
			firstName: this._lawyerFirstName,
			lastName: this._lawyerLastName,
			role: LawFirmEmployeeType.LAWYER,
			lawFirm: this.lawFirm,
		};
		const dialogRef = this.dialog.open(CreateLawFirmEmployeeComponent, {
			width: '800px',
			height: '500px',
			data: lawFirmEmployeeModel,
		});
		dialogRef
			.afterClosed()
			.pipe(untilDestroyed(this))
			.subscribe((result) => {
				if (result) {
					this.onCreateOrUpdateLawyer.emit({
						...result,
						role: LawFirmEmployeeType.LAWYER,
					});
				}
			});
	}

	searchLawyer(value) {
		this.lawyerSearchDispatch.Search({
			searchValue: value,
			lawFirmId: this.lawFirm.id,
			cardId: this.lawFirm.leap?.cardId,
			role: LawFirmEmployeeType.LAWYER,
		});
	}

	lawyerDropdownOptionSelect(event) {
		switch (event.result.name) {
			case 'Edit':
				this._lawyerFirstName = this.lawFirm.lawyer.firstName;
				this._lawyerLastName = this.lawFirm.lawyer.lastName;
				this.createOrUpdateLawyer();
				break;
			case 'Remove':
				this.removeLawyer();
				break;
		}
	}
}
